import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import CpfCnpj from "@react-br-forms/cpf-cnpj-mask";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import api from "assets/services/api";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";

import InputMask from 'react-input-mask';

const styles = {
    btnFindClient: {
        backgroundColor: "#4169e1",
        marginTop: "25%",
        '&:hover': {
            backgroundColor: '#303f9f',
        },
    },
    sizeAddContact: {
        color: "#4169e1",
        overflow: "visible"
    },
    buttonIcon: {
        fontSize: "50px",
        padding: "0"
    },

};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

function ModalAddZone(props) {

    const classStyles = useStyles();
    const classStyles2 = useStyles2();
    const { storageId, storageUserType } = useAuth();

    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);
    const [regions, setRegions] = useState([]);
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [idRegion, setIdRegion] = useState(null);
    useEffect(() => {
        getRegions();
    }, []);
    useEffect(() => {
        if (idRegion) {
            getLastCode();
        };
    }, [idRegion]);
    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);
    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                        props.getZones();
                        props.onHide();
                    }, 1500);
                }
                break;
            default:
                break;
        }
    };
    async function getLastCode() {
        const lastCode = await api.get(`/zone/last/${storageId}/${idRegion}?type=${storageUserType}`);
        if (lastCode.status === 200) {
            setCode(lastCode.data.code)
        }
    };
    async function getRegions() {
        try {
            const response = await api.get(`/region/${storageId}?type=${storageUserType}&search=`);
            setRegions(response.data.regions);
            setIdRegion(response.data.regions[0].id);
        } catch (error) {

        };
    };
    const handleAddZone = async (e) => {
        e.preventDefault();
        const addZone = await api.post('/zone', {
            code,
            name,
            id: storageId,
            id_region: idRegion,
            type: storageUserType
        });
        if (addZone.status === 200) {
            setControlSnack(true);
        };
    };

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar Zona
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddZone}>
                <Modal.Body >
                    <Form.Row>
                        <Form.Group as={Col} xs={3} controlId="formGridName">
                            <Form.Label>REGIÃO</Form.Label>
                            <Form.Control onChange={event => setIdRegion(event.target.value)} value={idRegion} as="select" defaultValue="Choose...">
                                {regions.map(region => (
                                    <option key={String(region.id)} value={region.id}>{region.name + "-" + region.code}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} xs={3} controlId="formGridName">
                            <Form.Label>CODIGO</Form.Label>
                            <Form.Control
                                value={code}
                                className="form-control"
                                placeholder="Codigo"
                                type="text"
                                onChange={(event) => {
                                    setCode(event.target.value)
                                }}
                                disabled
                            />
                        </Form.Group>
                        <Form.Group as={Col} xs={9} controlId="formGridNameZone">
                            <Form.Label>NOME</Form.Label>
                            <Form.Control
                                value={name}
                                className="form-control"
                                placeholder="Nome"
                                type="text"
                                onChange={(event) => {
                                    setName(event.target.value)
                                }}
                                autoComplete='off'
                                required
                            />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button type="submit" color="success">
                            Adicionar
                        </Button>
                    </div>
                    <Snackbar
                        place="br"
                        color="success"
                        icon={AddAlert}
                        message="Zona adicionado com sucesso"
                        open={br}
                        closeNotification={() => setBR(false)}
                        close
                    />
                </Modal.Footer>
            </Form>
        </Modal >
    );
}

export default ModalAddZone;